import { Button, Card, CardHeader, FormFeedback, FormGroup, Input, Label, ListGroup, ListGroupItem } from 'reactstrap';
import * as React from 'react';
import { useContext, useState } from 'react';
import { authAxios } from '../../../services/AxiosService';
import { notifyError, notifySuccess } from '../../../services/ToastService';
import { STAGE_ASSIGNED_TO_LAWYER, STAGE_RETURN_FOR_CONFLICT } from '../../../contexts/DomainContext';
import { useHistory, useParams } from 'react-router';
import { FileContext, IRejectedLawyer } from '../FileContext';
import { MyUserContext } from '../../../contexts/MyUserContext';
import { ConfirmModal } from '../../ConfirmModal/ConfirmModal';

export const LawyerRequestActions = () => {
  const params = useParams<{ fileId: string }>();
  const fileContext = useContext(FileContext);
  const myUserContext = useContext(MyUserContext);
  const file = fileContext.file;
  const setFile = fileContext.setFile;
  const history = useHistory();

  const [lawyerReason, setLawyerReason] = useState('');

  // Hidden temporarily for YLSS-638
  // const [tryAccept, setTryAccept] = useState(false);
  const [tryReject, setTryReject] = useState(false);

  // Hidden temporarily for YLSS-638
  // const [weight, setWeight] = useState<number | undefined>(undefined);
  // const [weightNotes, setWeightNotes] = useState('');

  const [acceptModal, setAcceptModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);

  const acceptRequest = () => {
    // Hidden temporarily for YLSS-638
    // if (weight) {
    // const data = { fileId: params.fileId, lawyerId: file?.lawyerId, weight: weight, notes: weightNotes };
    const data = { fileId: params.fileId, lawyerId: file?.lawyerId };
    authAxios.post('/api/files/admin/accept-lawyer-request', data).then((response) => {
      if (response.data.status === 'OK') {
        notifySuccess('Request Accepted.');
        fileContext.setLawOfficeNumber(response.data.lawOfficeNumber);
        setFile((f) => ({
          ...f,
          stageId: STAGE_ASSIGNED_TO_LAWYER,
          lawOfficeNumber: response.data.lawOfficeNumber,
          //Hidden temporarily for YLSS-638
          // lawyerFileWeights: f.lawyerFileWeights.concat({
          //   weight: weight,
          //   reasonId: LAWYER_FILE_WEIGHT_REASON_INITIAL,
          //   notes: weightNotes,
          // } as ILawyerFileWeight),
        }));
      } else {
        notifyError(response.data.errorMessage);
      }
    });
    // Hidden temporarily for YLSS-638
    // } else {
    //   setTryAccept(true);
    // }
  };

  const rejectRequest = (reason?: string) => {
    if (reason) {
      const data = { fileId: params.fileId, lawyerId: file?.lawyerId, reason };
      authAxios.post('/api/files/admin/reject-lawyer-request', data).then((response) => {
        if (response.data.status === 'OK') {
          notifySuccess('Request Rejected.');
          setFile((f) => ({
            ...f,
            lawyerId: undefined,
            officeId: undefined,
            stageId: STAGE_RETURN_FOR_CONFLICT,
            rejectedLawyers: [
              {
                lawyerId: f.lawyerId ? f.lawyerId : '',
                reason: reason,
                dateRejected: new Date().getTime(),
              },
            ].concat(f.rejectedLawyers ? f.rejectedLawyers : []) as IRejectedLawyer[],
          }));
          if (!myUserContext.isIntakeOffice) {
            history.push({ pathname: '/files', state: { deletedFileId: params.fileId } });
          }
        } else {
          notifyError(response.data.errorMessage);
        }
      });
    } else {
      setTryReject(true);
    }
  };

  //Hidden temporarily for YLSS-638
  // const weightOptions = [
  //   { val: 1, display: '1' },
  //   { val: 2, display: '2' },
  //   { val: 3, display: '3' },
  //   { val: 4, display: '4' },
  //   { val: 5, display: '5' },
  //   { val: 6, display: '6' },
  // ];
  //
  // const dropdownSelectStyles = {
  //   menu: (provided: any) => ({ ...provided, zIndex: 9999 }),
  // };

  return (
    <>
      <Card className={'bg-primary-light mb-3'}>
        <CardHeader>Accept or Reject Lawyer Request</CardHeader>
        <ListGroup flush={true}>
          <ListGroupItem className={'bg-primary-light'}>
            {/*Hidden temporarily for YLSS-638*/}
            {/*<Row>*/}
            {/*  <Col md={3}>*/}
            {/*    <FormGroup>*/}
            {/*      <Label>Complexity</Label>*/}
            {/*      <Select*/}
            {/*        styles={dropdownSelectStyles}*/}
            {/*        name={'Weight'}*/}
            {/*        options={weightOptions}*/}
            {/*        placeholder={'Select...'}*/}
            {/*        value={weightOptions.find((o) => o.val === weight)}*/}
            {/*        onChange={(value: any) => {*/}
            {/*          setWeight(value?.val || undefined);*/}
            {/*        }}*/}
            {/*        getOptionValue={(option: any) => option.val}*/}
            {/*        getOptionLabel={(option: any) => option.display}*/}
            {/*      />*/}
            {/*      {tryAccept && !weight && (*/}
            {/*        <span style={{ fontSize: 13, color: '#B22222' }}>This field is mandatory</span>*/}
            {/*      )}*/}
            {/*    </FormGroup>*/}
            {/*  </Col>*/}
            {/*  <Col md={9}>*/}
            {/*    <FormGroup>*/}
            {/*      <Label>Notes</Label>*/}
            {/*      <Input*/}
            {/*        value={weightNotes}*/}
            {/*        type={'text'}*/}
            {/*        name={'Notes'}*/}
            {/*        autoComplete={'off'}*/}
            {/*        onChange={(e: any) => setWeightNotes(e.target.value)}*/}
            {/*      />*/}
            {/*    </FormGroup>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
            <Button color='success' className='ml-auto' onClick={() => setAcceptModal(true)}>
              Accept Request
            </Button>
          </ListGroupItem>
          <ListGroupItem className={'bg-primary-light'}>
            <FormGroup>
              <Label for={'reason'}>If rejecting, please provide a reason</Label>
              <Input
                value={lawyerReason}
                type={'text'}
                name={'Reason'}
                autoComplete={'off'}
                onChange={(e: any) => setLawyerReason(e.target.value)}
                invalid={tryReject && lawyerReason === ''}
              />
              <FormFeedback>This field is mandatory</FormFeedback>
            </FormGroup>
            <Button
              color='danger'
              className='ml-auto'
              onClick={() => {
                setTryReject(true);
                if (lawyerReason) {
                  setRejectModal(true);
                }
              }}
            >
              Reject Request
            </Button>
          </ListGroupItem>
        </ListGroup>
      </Card>
      <ConfirmModal
        isOpen={acceptModal}
        title={'Accept'}
        onConfirm={() => {
          setAcceptModal(false);
          acceptRequest();
        }}
        onCancel={() => setAcceptModal(false)}
        confirmButton={'Accept'}
      >
        <div>Are you sure you want to accept the request?</div>
      </ConfirmModal>
      <ConfirmModal
        isOpen={rejectModal}
        title={'Reject'}
        onConfirm={() => {
          setRejectModal(false);
          rejectRequest(lawyerReason);
        }}
        onCancel={() => setRejectModal(false)}
        confirmButton={'Reject'}
      >
        <div>Are you sure you want to reject the request?</div>
      </ConfirmModal>
    </>
  );
};
